module.exports = __webpack_public_path__ + "static/img/cuc_logo.2316f3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cuc_logo.png
// module id = kcIO
// module chunks = 3